<template>
	<div class="job-evaluation-poll-progress">
		<span class="text-info relative" style="bottom: -5px">Puestos</span>
		<div class="tw-flex">
			<factor-progress-bar
				:length="sizeCount"
				:completed-items-count="completedCount"
				:show-text="false"
				class="tw-flex-auto"
			/>
			<span class="text-secondary tw-w-14 tw-text-center">{{ completedCount  }} / {{ sizeCount }}</span>
		</div>
	</div>
</template>

<script>
import FactorProgressBar
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/commons/FactorProgressBar';

export default {
	name: 'JobEvaluationPollProgress',
	components: { FactorProgressBar },
	props: ['completedCount', 'sizeCount'],
};
</script>

<style lang="scss" scoped>
.job-evaluation-poll-progress {
	width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/modules/polls/components/custom/JobEvaluationPollPage/JobEvaluationPollProgress.vue